'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

require('moment-range');

var _dayView = require('./day-view');

var _dayView2 = _interopRequireDefault(_dayView);

var _monthView = require('./month-view');

var _monthView2 = _interopRequireDefault(_monthView);

var _yearView = require('./year-view');

var _yearView2 = _interopRequireDefault(_yearView);

var _util = require('./util');

var _util2 = _interopRequireDefault(_util);

var _icon = require('./icon');

var _icon2 = _interopRequireDefault(_icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Calendar = function (_React$Component) {
  (0, _inherits3.default)(Calendar, _React$Component);

  function Calendar(props, context) {
    (0, _classCallCheck3.default)(this, Calendar);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Calendar.__proto__ || (0, _getPrototypeOf2.default)(Calendar)).call(this, props, context));

    _initialiseProps.call(_this);

    _moment2.default.locale(_this.props.locale || 'en');
    var format = props.format || 'MM-DD-YYYY';
    var computableFormat = props.computableFormat || 'MM-DD-YYYY';
    var strictDateParsing = props.strictDateParsing || false;
    var parsingFormat = props.parsingFormat || format;
    var date = props.date ? (0, _moment2.default)(props.date, parsingFormat) : null;
    var minDate = props.minDate ? (0, _moment2.default)(props.minDate, parsingFormat) : null;
    var maxDate = props.maxDate ? (0, _moment2.default)(props.maxDate, parsingFormat) : null;
    var minView = parseInt(props.minView, 10) || 0;
    var defaultView = parseInt(props.defaultView, 10) || 0;
    var displayYrWithMonth = props.displayYrWithMonth || false;
    var currentView = defaultView < minView ? minView : defaultView;
    var keyboardDisabled = props.keyboardDisabled;

    _this.state = {
      date: date,
      minDate: minDate,
      maxDate: maxDate,
      format: format,
      computableFormat: computableFormat,
      inputValue: date ? date.format(format) : undefined,
      views: ['days', 'months', 'years'],
      minView: minView,
      currentView: currentView,
      isVisible: false,
      strictDateParsing: strictDateParsing,
      parsingFormat: parsingFormat,
      keyboardDisabled: keyboardDisabled,
      displayYrWithMonth: displayYrWithMonth
    };
    return _this;
  }

  (0, _createClass3.default)(Calendar, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.addEventListener('click', this.documentClick);
      if (this.props.focused) {
        this.focusDateInput();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var newState = {
        date: nextProps.date ? (0, _moment2.default)(nextProps.date, this.state.parsingFormat) : this.state.date,
        inputValue: nextProps.date ? (0, _moment2.default)(nextProps.date, this.state.parsingFormat).format(this.state.format) : null,
        minDate: nextProps.minDate ? (0, _moment2.default)(nextProps.minDate, this.state.parsingFormat) : null,
        maxDate: nextProps.maxDate ? (0, _moment2.default)(nextProps.maxDate, this.state.parsingFormat) : null
      };

      if (nextProps.disabled === true) {
        newState.isVisible = false;
      }

      this.setState(newState);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.props.focused !== prevProps.focused && this.props.focused) {
        this.focusDateInput();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('click', this.documentClick);
    }
  }, {
    key: 'setVisibility',
    value: function setVisibility(val) {
      var value = val !== undefined ? val : !this.state.isVisible;
      var eventMethod = value ? 'addEventListener' : 'removeEventListener';

      !this.state.keyboardDisabled && document[eventMethod]('keydown', this.keyDown);

      if (this.state.isVisible !== value && !this.props.disabled) {
        this.setState({ isVisible: value });
      }
    }
  }, {
    key: 'checkIfDateDisabled',
    value: function checkIfDateDisabled(date) {
      return date && this.state.minDate && date.isBefore(this.state.minDate, 'day') || date && this.state.maxDate && date.isAfter(this.state.maxDate, 'day');
    }
  }, {
    key: 'getView',
    value: function getView() {
      var calendarDate = this.state.date || (0, _moment2.default)();
      var _state = this.state,
          maxDate = _state.maxDate,
          minDate = _state.minDate,
          displayYrWithMonth = _state.displayYrWithMonth;

      var props = {
        date: calendarDate,
        nextView: this.nextView,
        setInputDate: this.setInputDate,
        setInternalDate: this.setInternalDate,
        prevView: this.prevView,
        maxDate: maxDate,
        minDate: minDate,
        displayYrWithMonth: displayYrWithMonth
      };

      switch (this.state.currentView) {
        case 0:
          return _react2.default.createElement(_dayView2.default, props);
        case 1:
          return _react2.default.createElement(_monthView2.default, props);
        case 2:
          return _react2.default.createElement(_yearView2.default, props);
        default:
          return _react2.default.createElement(_dayView2.default, props);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      // its ok for this.state.date to be null, but we should never
      // pass null for the date into the calendar pop up, as we want
      // it to just start on todays date if there is no date set
      var view = this.getView();
      var todayText = this.props.todayText || (_moment2.default.locale() === 'de' ? 'Heute' : 'Today');
      var calendarClass = (0, _classnames2.default)({
        'input-calendar-wrapper': true,
        'icon-hidden': this.props.hideIcon
      });
      var calendar = !this.state.isVisible || this.props.disabled ? '' : _react2.default.createElement(
        'div',
        { className: calendarClass, onClick: this.calendarClick },
        view,
        this.props.hideTodayButton ? undefined : _react2.default.createElement(
          'span',
          {
            className: 'today-btn' + (this.checkIfDateDisabled((0, _moment2.default)().startOf('day')) ? ' disabled' : ''),
            onClick: this.todayClick
          },
          todayText
        )
      );
      var readOnly = _util2.default.checkForMobile(this.props.hideTouchKeyboard);
      var calendarIcon = (0, _icon2.default)(this.props, this.toggleClick);
      var inputClass = this.props.inputFieldClass || 'input-calendar-field';

      return _react2.default.createElement(
        'div',
        { className: 'input-calendar' },
        _react2.default.createElement('input', {
          name: this.props.inputName,
          className: inputClass,
          id: this.props.inputFieldId,
          onBlur: this.inputBlur,
          onChange: this.changeDate,
          onFocus: this.inputFocus,
          onKeyUp: this.inputKeyUp,
          onKeyDown: this.inputKeyDown,
          placeholder: this.props.placeholder,
          readOnly: readOnly,
          disabled: this.props.disabled,
          type: 'text',
          ref: function ref(input) {
            _this2.dateInput = input;
          },
          value: this.state.inputValue || ''
        }),
        calendarIcon,
        calendar
      );
    }
  }]);
  return Calendar;
}(_react2.default.Component);

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.setInputDate = function (date) {
    var isDayView = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    if (_this3.checkIfDateDisabled(date)) return;

    _this3.setState({
      date: date,
      inputValue: date.format(_this3.state.format),
      isVisible: _this3.props.closeOnSelect && isDayView ? !_this3.state.isVisible : _this3.state.isVisible
    });

    if (_this3.props.onChange) {
      _this3.props.onChange(date.format(_this3.state.computableFormat));
    }
  };

  this.setInternalDate = function (date) {
    var isDayView = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    if (_this3.checkIfDateDisabled(date)) return;

    _this3.setState({
      date: date
    });
  };

  this.calendarClick = function () {
    _this3.setState({ isCalendar: true });
  };

  this.changeDate = function (e) {
    //eslint-disable-line
    _this3.setState({ inputValue: e.target.value });
  };

  this.documentClick = function (e) {
    if (!_this3.state.isCalendar) {
      _this3.setVisibility(false);
    }
    _this3.setState({ isCalendar: false });
  };

  this.focusDateInput = function () {
    _this3.dateInput && _this3.dateInput.focus();
  };

  this.inputBlur = function (e) {
    var newDate = null;
    var computableDate = null;
    var date = _this3.state.inputValue;
    var format = _this3.state.format;
    var parsingFormat = _this3.state.parsingFormat;

    if (date) {
      // format, with strict parsing true, so we catch bad dates
      newDate = (0, _moment2.default)(date, parsingFormat, _this3.props.strictDateParsing);
      // if the new date didn't match our format, see if the native
      // js date can parse it
      if (!newDate.isValid()) {
        var d = new Date(date);
        // if native js cannot parse, just make a new date
        if (isNaN(d.getTime())) {
          d = new Date();
        }
        newDate = (0, _moment2.default)(d);
      }

      computableDate = newDate.format(_this3.state.computableFormat);
    }

    _this3.setState({
      date: newDate,
      inputValue: newDate ? newDate.format(format) : null
    });

    _this3.props.onChange && _this3.props.onChange(computableDate);
    _this3.props.onBlur && _this3.props.onBlur(e, computableDate);
  };

  this.inputFocus = function (e) {
    if (_this3.props.openOnInputFocus) {
      _this3.toggleClick();
    }
    _this3.props.onFocus && _this3.props.onFocus(e);
  };

  this.keyDown = function (e) {
    _util2.default.keyDownActions.call(_this3, e.keyCode);
  };

  this.inputKeyUp = function (e) {
    _this3.props.onInputKeyUp && _this3.props.onInputKeyUp(e);
  };

  this.inputKeyDown = function (e) {
    _this3.props.onInputKeyDown && _this3.props.onInputKeyDown(e);
  };

  this.nextView = function () {
    if (_this3.checkIfDateDisabled(_this3.state.date)) return;
    _this3.setState({ currentView: ++_this3.state.currentView });
  };

  this.prevView = function (date) {
    var newDate = date;
    if (_this3.state.minDate && date.isBefore(_this3.state.minDate, 'day')) {
      newDate = _this3.state.minDate.clone();
    }

    if (_this3.state.maxDate && date.isAfter(_this3.state.maxDate, 'day')) {
      newDate = _this3.state.maxDate.clone();
    }

    if (_this3.state.currentView === _this3.state.minView) {
      _this3.setState({
        date: newDate,
        inputValue: date.format(_this3.state.format),
        isVisible: false
      });
      if (_this3.props.onChange) {
        _this3.props.onChange(date.format(_this3.state.computableFormat));
      }
    } else {
      _this3.setState({
        date: date,
        currentView: --_this3.state.currentView
      });
    }
  };

  this.todayClick = function () {
    var today = (0, _moment2.default)().startOf('day');

    if (_this3.checkIfDateDisabled(today)) return;

    _this3.setState({
      date: today,
      inputValue: today.format(_this3.state.format),
      currentView: _this3.state.minView
    });

    if (_this3.props.onChange) {
      _this3.props.onChange(today.format(_this3.state.computableFormat));
    }
  };

  this.toggleClick = function () {
    _this3.setState({ isCalendar: true });
    _this3.setVisibility();
  };
};

Calendar.propTypes = {
  closeOnSelect: _propTypes2.default.bool,
  computableFormat: _propTypes2.default.string,
  strictDateParsing: _propTypes2.default.bool,
  parsingFormat: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]),
  date: _propTypes2.default.any,
  minDate: _propTypes2.default.any,
  maxDate: _propTypes2.default.any,
  format: _propTypes2.default.string,
  inputName: _propTypes2.default.string,
  inputFieldId: _propTypes2.default.string,
  inputFieldClass: _propTypes2.default.string,
  minView: _propTypes2.default.number,
  onBlur: _propTypes2.default.func,
  hideOnBlur: _propTypes2.default.bool,
  onChange: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  onInputKeyUp: _propTypes2.default.func,
  onInputKeyDown: _propTypes2.default.func,
  openOnInputFocus: _propTypes2.default.bool,
  placeholder: _propTypes2.default.string,
  hideTouchKeyboard: _propTypes2.default.bool,
  hideIcon: _propTypes2.default.bool,
  hideTodayButton: _propTypes2.default.bool,
  customIcon: _propTypes2.default.string,
  todayText: _propTypes2.default.string,
  disabled: _propTypes2.default.bool,
  focused: _propTypes2.default.bool,
  locale: _propTypes2.default.string,
  keyboardDisabled: _propTypes2.default.bool
};

exports.default = Calendar;


//////////////////
// WEBPACK FOOTER
// ./~/react-input-calendar/dist/index.js
// module id = 1244
// module chunks = 3